export default "__VITE_ASSET__accfe784__"